module.exports = false;



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp/3203/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_library.js
// module id = 29
// module chunks = 0